import React from "react";
import ProductCard from "./ProductCard";

export default function SearchResults({ products, primaryMenu }) {
  let valueProp;
  let title;
  if (primaryMenu === 0 || primaryMenu === 3) {
    valueProp = "excerpt";
    title = "";
  }
  if (primaryMenu === 1) {
    valueProp = "attributes";
    title = "Attributes";
  }
  if (primaryMenu === 2) {
    valueProp = "markets";
    title = "Markets";
  }

  return (
    <div className="p-4 flex flex-wrap">
      {products.map((p) => {
        const product = p.item || p;
        return (
          <ProductCard
            key={product.id}
            product={product}
            title={title}
            tagline={product.excerpt}
            valueProps={product[valueProp]}
          />
        );
      })}
    </div>
  );
}
